module.exports = __webpack_public_path__ + "img/vrglasses.afd948f8.svg";